import { render, staticRenderFns } from "./mywork.vue?vue&type=template&id=40875f76&scoped=true"
import script from "./mywork.vue?vue&type=script&lang=js"
export * from "./mywork.vue?vue&type=script&lang=js"
import style0 from "./mywork.vue?vue&type=style&index=0&id=40875f76&prod&scoped=true&lang=scss"
import style1 from "./mywork.vue?vue&type=style&index=1&id=40875f76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40875f76",
  null
  
)

/* custom blocks */
import block0 from "./mywork.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports